import React, { useState } from 'react'
import { actualizarDatos, cancelarEquipo, consultarCancelacionDependientesOt } from '../../api/common'
import Spinner from '../commons/Spinner'
import { Modalcarga } from '../Modales/Modalcarga'
import { Alertassw } from '../Alertas/Alertassw'
import { useAuth } from "../../hooks/useAuth";
import { ActualizarEqOtIni } from '../Ot/actualizarEqOtIni'
import ModalConfirmarCancelacionDependientes from '../Ot/ModalConfirmarCancelacionDependientes'
import ModalConfirmarAccionPareja from '../Ot/ModalConfirmarAccionPareja'

export const  Canceleq=({infoOt, iditem, cambiarestado, setEquiposOtIni, refresh, setRefresh, actualizarOt=false })=> {

  console.log(infoOt)
    const [modalcharge, SetModalcharge]=useState(false)
    const { userData } = useAuth();
    console.log(userData)
    const [datacancel, setDatacancel]=useState({
        equipo:iditem,
        comment:'',
        responsable:userData._id
    })
    // Modal de confirmación de cancelación con pareja
    // (spec equipos-dependientes-sincronizacion-cancelacion).
    const [modalParejas, setModalParejas] = useState({ show: false, parejas: [] })
    // Modal genérico para acción "Pendiente" con pareja (misma UX que activar/aplazar/desaprobar).
    const [modalPendientePareja, setModalPendientePareja] = useState({ show: false, parejas: [] })
    const handledata=(event)=>{
        //console.log(datacancel)
        setDatacancel({
            ...datacancel,
            [event.target.name] : event.target.value
      })
    }

    // Ejecuta un cambio de estado 'Pendiente' sobre un EquipmentInOt (id).
    // Reutilizable para el equipo original y su pareja.
    const ejecutarPendiente = async (eqInOtId, observacionOverride) => {
      try {
        const result = await actualizarDatos('EqInOt', {
            _id: eqInOtId,
            estado: 'Pendiente',
            observacion: observacionOverride ?? datacancel.comment,
            responsable: userData._id,
            responsableChange: userData,
            visita: infoOt.visitas || 0,
            numeroOrden: infoOt.numeroOrden,
            change: true,
        }, eqInOtId, infoOt._id)
        return result?.status === 200
      } catch (err) {
        console.warn('[Canceleq.wait] Falló Pendiente en', eqInOtId, err.message)
        return false
      }
    }

    const wait = async () => {
      if (!(datacancel.comment && datacancel.comment !== '')) {
        Alertassw('error', 'Por favor describe el motivo')
        return
      }
      SetModalcharge(true)
      try {
        // Consulta previa: ¿el equipo tiene pareja en la misma OT?
        // excluirEstados=[] → mostrar pareja aunque esté en Cancelado (podría querer
        // pasar a Pendiente también).
        const respuesta = await consultarCancelacionDependientesOt(infoOt._id, [iditem], [])
        const parejas = respuesta?.data?.parejas || []
        if (parejas.length === 0) {
          const ok = await ejecutarPendiente(iditem)
          SetModalcharge(false)
          if (ok) {
            Alertassw('toast', 'Cambio registrado exitosamente')
            cambiarestado(false)
            setRefresh(!refresh)
          }
          return
        }
        SetModalcharge(false)
        setModalPendientePareja({ show: true, parejas })
      } catch (err) {
        SetModalcharge(false)
        console.warn('[Canceleq.wait] Error consulta pareja, ejecutando directo:', err.message)
        const ok = await ejecutarPendiente(iditem)
        if (ok) {
          Alertassw('toast', 'Cambio registrado exitosamente')
          cambiarestado(false)
          setRefresh(!refresh)
        }
      }
    }

    const handlePendienteAmbos = async (equiposParejaCompletos) => {
      setModalPendientePareja({ show: false, parejas: [] })
      SetModalcharge(true)
      const okOriginal = await ejecutarPendiente(iditem)
      let okPareja = true
      for (const parejaEq of (equiposParejaCompletos || [])) {
        if (!parejaEq?._id) continue
        const ok = await ejecutarPendiente(String(parejaEq._id))
        okPareja = okPareja && ok
      }
      SetModalcharge(false)
      if (okOriginal) {
        Alertassw('toast', `Cambio registrado exitosamente${okPareja ? ' (equipo + pareja)' : ''}`)
        cambiarestado(false)
        setRefresh(!refresh)
      }
    }

    const handlePendienteSolo = async () => {
      setModalPendientePareja({ show: false, parejas: [] })
      SetModalcharge(true)
      const ok = await ejecutarPendiente(iditem)
      SetModalcharge(false)
      if (ok) {
        Alertassw('toast', 'Cambio registrado exitosamente')
        cambiarestado(false)
        setRefresh(!refresh)
      }
    }

    const handlePendienteCancelar = () => {
      setModalPendientePareja({ show: false, parejas: [] })
    }

    // Ejecuta la cancelación con el body preparado. `bodyExtra` puede traer
    // `equiposPareja`, `omitirCancelacionPareja`, `motivoOmision` para el flujo
    // de pareja (spec equipos-dependientes-sincronizacion-cancelacion).
    const ejecutarCancelacion = async (bodyExtra = {}) => {
      try {
        SetModalcharge(true)
        const bodyFinal = { ...datacancel, ...bodyExtra }
        const result = await cancelarEquipo('Ot', bodyFinal, infoOt._id, infoOt.numeroOrden)
        console.log(result)
        if (result.status === 200) {
          const canceladas = 1 + ((result.data.parejasCanceladas && result.data.parejasCanceladas.length) || 0)
          const msg = canceladas > 1
            ? `${canceladas} equipos cancelados exitosamente (incluyendo pareja).`
            : 'Equipo cancelado exitosamente'
          Alertassw('success', msg)
          SetModalcharge(false)
          cambiarestado(false)
          setRefresh && setRefresh(!refresh)
          if (actualizarOt) {
            ActualizarEqOtIni(setEquiposOtIni, result.data.updateEqInOt)
          }
        }
      } catch (error) {
        SetModalcharge(false)
        console.error(error)
        // Backend puede devolver 400 con PAREJA_DEPENDIENTE_NO_CANCELADA si
        // se saltó la consulta previa. Es defensa en profundidad — abrimos modal.
        const backendError = error?.response?.data
        if (backendError?.error === 'PAREJA_DEPENDIENTE_NO_CANCELADA' && Array.isArray(backendError?.parejas)) {
          setModalParejas({ show: true, parejas: backendError.parejas })
          return
        }
        Alertassw('error', 'Error al cancelar el equipo')
      }
    }

    const handleSubmit = async (e) => {
      e.preventDefault();
      editarcoment()

      // Consulta previa: ¿tiene pareja en la misma OT?
      SetModalcharge(true)
      try {
        const respuesta = await consultarCancelacionDependientesOt(infoOt._id, [iditem])
        const parejas = respuesta?.data?.parejas || []
        SetModalcharge(false)
        if (parejas.length === 0) {
          await ejecutarCancelacion()
          return
        }
        setModalParejas({ show: true, parejas })
      } catch (error) {
        SetModalcharge(false)
        console.error('Error consultando pareja:', error)
        // Fallback: intentar cancelación directa. Si el backend tiene pareja no
        // incluida, responderá 400 y el catch de ejecutarCancelacion abre el modal.
        await ejecutarCancelacion()
      }
    }

    const handleModalCancelarAmbos = async (equiposParejaIds) => {
      setModalParejas({ show: false, parejas: [] })
      // Normalizar defensivamente a array de strings (por si vienen objetos).
      const ids = (equiposParejaIds || []).map(x =>
        typeof x === 'string' ? x : (x?._id ? String(x._id) : String(x))
      ).filter(id => id && id.length === 24)
      await ejecutarCancelacion({ equiposPareja: ids })
    }

    const handleModalSoloEste = async (motivoOmision) => {
      setModalParejas({ show: false, parejas: [] })
      await ejecutarCancelacion({ omitirCancelacionPareja: true, motivoOmision })
    }

    const handleModalNoCancelar = () => {
      setModalParejas({ show: false, parejas: [] })
      // No hace nada — el usuario abandonó la cancelación.
    }

     function editarcoment(){
      datacancel.comment="Cancelado : "+ datacancel.comment
      console.log(datacancel.comment)
    }

  return (
    <div>
        <Modalcarga
        estadoIn={modalcharge} 
        cambiarestadoIn={SetModalcharge}
        >
          <Spinner />
        </Modalcarga>
       <form className='col-1-grid w-100' onSubmit={handleSubmit}>
            <div className='w-100'>
                            <p className='color-red'>* Describa el motivo por el cual se realiza la cancelacion del equipo</p>
                            <textarea  onChange={handledata} name='comment' className='titulo w-100' type={'string'}  required ></textarea>
                    </div>
            <button className='btn-btn-primary center-grid ' type='submit'>Cancelar equipo</button>
       </form>
       <button className='btn-btn-secundary center-grid' onClick={wait}>Pendiente</button>

       {modalParejas.show && (
         <ModalConfirmarCancelacionDependientes
           show={modalParejas.show}
           parejas={modalParejas.parejas}
           onCancelarAmbos={handleModalCancelarAmbos}
           onSoloEste={handleModalSoloEste}
           onNoCancelarNada={handleModalNoCancelar}
         />
       )}

       {modalPendientePareja.show && (
         <ModalConfirmarAccionPareja
           show={modalPendientePareja.show}
           accionLabel="marcar como Pendiente"
           parejas={modalPendientePareja.parejas}
           onAplicarAmbos={handlePendienteAmbos}
           onSoloEste={handlePendienteSolo}
           onNoHacerNada={handlePendienteCancelar}
         />
       )}
    </div>
  )
}
